import React from "react";
import { Container, Grid, Box, Typography } from "@mui/material";
import "../styles/Section1.css";
import PermIdentityRoundedIcon from "@mui/icons-material/PermIdentityRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import VideoCameraFrontRoundedIcon from "@mui/icons-material/VideoCameraFrontRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";

const Works = () => {
  const workSteps = [
    {
      icon: <PermIdentityRoundedIcon sx={{ fontSize: 28 }} />,
      step: "01",
      title: "Register & NIN Verify",
      description:
        "Sign up in seconds using your Email or NIN. Patients get instant access, while doctors verify credentials securely.",
    },
    {
      icon: <AccountBalanceWalletRoundedIcon sx={{ fontSize: 28 }} />,
      step: "02",
      title: "Fund Health Wallet",
      description:
        "Load your in-app wallet via bank transfer or cards in Naira (₦). Zero hidden charges and ready for instant checkout.",
    },
    {
      icon: <VideoCameraFrontRoundedIcon sx={{ fontSize: 28 }} />,
      step: "03",
      title: "Book Consultation",
      description:
        "Select your preferred specialist and start an encrypted HD video, voice, or messaging session from anywhere.",
    },
    {
      icon: <AssignmentTurnedInRoundedIcon sx={{ fontSize: 28 }} />,
      step: "04",
      title: "Rx & Transparent Care",
      description:
        "Receive digital prescriptions instantly. In case of unexpected doctor unavailability, receive an immediate full refund.",
    },
  ];

  return (
    <Box className="work-section-wrap">
      <Container maxWidth="xl">
        <Typography className="work-main-heading">
          How Telemedicine Works
        </Typography>
        <Typography className="work-subheading">
          High-quality medical consultations delivered directly to your smartphone in 4 easy steps.
        </Typography>

        <Grid container spacing={3}>
          {workSteps.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <div className="work-step-card">
                <span className="step-number-tag">STEP {item.step}</span>
                <div className="work-icon-circle">
                  {item.icon}
                </div>
                <div className="work-card-title">{item.title}</div>
                <div className="work-card-desc">{item.description}</div>
              </div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Works;
